/* Magnetix IL — poster page extras (mgx-poster-extras.js), loaded after mgx-poster-builder.js.
 * 1. Gallery slide 2 (#mtx): a live 3D "how it works" scene: wall sticker, magnet and the customer's poster
 *    (blank metal until a photo is in). Three "+" spots explain each part. The poster grows with the size
 *    and turns with the orientation. Sizes listed in CFG.doubleSizes get two sticker + magnet pairs.
 * 2. "לצפייה במידות" (#mtp-size-guide): a sheet with a person holding each size, with the customer's poster
 *    in their hands. Tapping a size picks it in the builder.
 * Both follow the builder through the `mtp:preview` event (window.mtpPreview holds the latest one).
 */
(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }
  var cfgEl = $('mtp-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var preview = window.mtpPreview || null;

  var T = {
    kit: 'בכל הזמנה: פוסטר, מגנט ומדבקה',
    hint: 'לחצו על + כדי להכיר כל חלק',
    cm: 'ס״מ',
    gloss: 'מבריק', matte: 'מאט',
    close: 'סגירה',
    prevPart: 'לחלק הקודם', nextPart: 'לחלק הבא',
    parts: {
      plate: { title: 'הפוסטר שלכם, מודפס על מתכת', text: function () {
        return 'הדפסה חדה ומדויקת על לוח מתכת דק וקל, בגימור מבריק או מאט לבחירתכם. הצבעים עזים ונשארים חיים לאורך שנים.';
      } },
      magnet: { title: 'מגנט חזק במיוחד', text: function () {
        return 'מחזיק את הפוסטר יציב על הקיר. רוצים להזיז, ליישר או להחליף? פשוט מורידים ומצמידים שוב, בלי מסמרים ובלי קדיחה.';
      } },
      sticker: { title: 'מדבקת הגנה לקיר', text: function () {
        return 'נדבקת לקיר ושומרת עליו, והמגנט נצמד אליה. כשתרצו להוריד, מקלפים לאט מהפינה ולא נשאר סימן.';
      } }
    },
    sheetTitle: 'איזה גודל מתאים לכם?',
    sheetSub: 'כך נראה כל גודל ביד. לחצו על גודל כדי לבחור אותו.',
    sheetLandscape: 'ההדמיה כאן היא רק להמחשת הגודל. הפוסטר שלכם לרוחב, ואפשר לתלות אותו לרוחב בלי שום בעיה.',
    picked: 'נבחר'
  };

  function sizesList() { return (preview && preview.sizes) || [{ id: 'M', a: 20, b: 30 }, { id: 'L', a: 30, b: 45 }, { id: 'XL', a: 40, b: 60 }]; }
  function sizeIndex(id) { var s = sizesList(); for (var i = 0; i < s.length; i++) if (s[i].id === id) return i; return 0; }
  function dimsText(p) {
    var s = sizesList()[sizeIndex(p.size)];
    return p.orientation === 'landscape' ? s.b + '×' + s.a : s.a + '×' + s.b;
  }
  // Draws the builder's crop into `canvas`, covering a w x h frame
  function paintCover(canvas, src, w, h) {
    canvas.width = w; canvas.height = h;
    var ctx = canvas.getContext('2d');
    var r = src.width / src.height, cr = w / h;
    var dw = r > cr ? h * r : w, dh = r > cr ? h : w / r;
    ctx.drawImage(src, (w - dw) / 2, (h - dh) / 2, dw, dh);
  }

  // ---------- 1. "How it works" scene ----------
  var mtx = $('mtx');
  var plateCanvas = null, card = null, activeKey = '';
  // The wall sticker as printed: where the magnet goes, how to press it, and which walls it's not for
  var HE = 'font-family="Rubik, Heebo, Arial, sans-serif" direction="rtl" text-anchor="middle" fill="#141414"';
  var STICKER_SVG =
    '<svg viewBox="0 0 200 200" aria-hidden="true">' +
      '<rect width="200" height="200" rx="3" fill="#FBE8CC"/>' +
      '<text x="41" y="40" direction="ltr" textLength="114" lengthAdjust="spacingAndGlyphs" font-family="Rubik, Arial, sans-serif" font-weight="800" font-size="27" fill="#141414">Magnetix</text>' +
      '<rect x="158" y="30" width="5" height="5" fill="#E5487B"/><rect x="158" y="36" width="5" height="4" fill="#1E5BD8"/>' +
      '<rect x="46" y="52" width="108" height="94" fill="none" stroke="#1d1d1d" stroke-width="1.3"/>' +
      '<path d="M139 65v-5a4 4 0 0 1 8 0v5M139 62h3M144 62h3" fill="none" stroke="#1d1d1d" stroke-width="1.2"/>' +
      '<path d="M53 139v-5a4 4 0 0 1 8 0v5M53 136h3M58 136h3" fill="none" stroke="#1d1d1d" stroke-width="1.2"/>' +
      '<text x="100" y="95" ' + HE + ' font-weight="800" font-size="17">הניחו את</text>' +
      '<text x="100" y="116" ' + HE + ' font-weight="800" font-size="17">המגנט כאן</text>' +
      '<text x="100" y="163" ' + HE + ' font-weight="700" font-size="10">לחצו חזק לפחות 5 שניות.</text>' +
      '<line x1="48" y1="167" x2="152" y2="167" stroke="#D3262F" stroke-width="1.4"/>' +
      '<path d="M163 186l6-11 6 11z" fill="none" stroke="#141414" stroke-width="1.1"/><path d="M169 179v3.4M169 184v.2" stroke="#141414" stroke-width="1.1"/>' +
      '<text x="96" y="180" ' + HE + ' font-weight="500" font-size="6.8">המדבקה והמגנט לא מיועדים לשימוש</text>' +
      '<text x="96" y="189" ' + HE + ' font-weight="500" font-size="6.8">על קירות מחוספסים או לא איכותיים.</text>' +
    '</svg>';
  var ORDER = ['sticker', 'magnet', 'plate']; // left to right on screen, for the arrows
  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 6 9 12 15 18"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="12" y1="6" x2="12" y2="18"/><line x1="6" y1="12" x2="18" y2="12"/></svg>';

  function hot(key, label) {
    return '<button type="button" class="mtx-hot" data-k="' + key + '" aria-label="' + label + '" aria-expanded="false">' + PLUS + '</button>';
  }
  function pairHTML(y, withHot) {
    return '<div class="mtx-layer mtx-sticker" style="--y:' + y + 'em">' + STICKER_SVG + (withHot ? hot('sticker', T.parts.sticker.title) : '') + '</div>' +
      '<div class="mtx-layer mtx-magnet" style="--y:' + (y + 0.55) + 'em"><i class="mtx-magnet__side"></i><i class="mtx-magnet__top"></i>' + (withHot ? hot('magnet', T.parts.magnet.title) : '') + '</div>';
  }
  var pairsFor = ''; // which layout the rig was last built for ('1' or '2' pairs)
  function buildRig(double) {
    var key = double ? '2' : '1';
    if (pairsFor === key) return;
    pairsFor = key;
    var rig = mtx.querySelector('.mtx-rig');
    var pairs = double ? pairHTML(-15, true) + pairHTML(15, false) : pairHTML(0, true);
    rig.innerHTML = pairs +
      '<div class="mtx-layer mtx-plate is-blank">' +
        '<i class="mtx-plate__edge"></i><canvas class="mtx-plate__img"></canvas><i class="mtx-plate__sheen"></i>' +
        hot('plate', T.parts.plate.title) +
      '</div>';
    plateCanvas = rig.querySelector('.mtx-plate__img');
  }

  if (mtx) {
    mtx.innerHTML =
      '<div class="mtx-scene">' +
        '<span class="mtx-kit">' + T.kit + '</span>' +
        '<div class="mtx-cam" id="mtx-cam"><div class="mtx-rig"></div></div>' +
        '<span class="mtx-size" id="mtx-size"></span>' +
        '<span class="mtx-hint" id="mtx-hint">' + T.hint + '</span>' +
        // The explanation sits next to the zoomed part, with arrows to the part on its left / right
        '<div class="mtx-pop" id="mtx-pop" hidden>' +
          '<button type="button" class="mtx-nav" data-d="-1" aria-label="' + T.prevPart + '">' + CHEV + '</button>' +
          '<div class="mtx-card" id="mtx-card" dir="rtl" role="status">' +
            '<button type="button" class="mtx-card__x" aria-label="' + T.close + '"><svg viewBox="0 0 24 24"><line x1="7" y1="7" x2="17" y2="17"/><line x1="17" y1="7" x2="7" y2="17"/></svg></button>' +
            '<b class="mtx-card__t"></b><p class="mtx-card__p"></p>' +
          '</div>' +
          '<button type="button" class="mtx-nav mtx-nav--next" data-d="1" aria-label="' + T.nextPart + '">' + CHEV + '</button>' +
        '</div>' +
      '</div>';
    card = $('mtx-card');
    buildRig(false);

    mtx.addEventListener('click', function (e) {
      var h = e.target.closest('.mtx-hot');
      if (h) { e.stopPropagation(); openPart(activeKey === h.dataset.k ? '' : h.dataset.k); return; }
      var nav = e.target.closest('.mtx-nav');
      if (nav) {
        e.stopPropagation();
        var i = ORDER.indexOf(activeKey) + Number(nav.dataset.d);
        openPart(ORDER[(i + ORDER.length) % ORDER.length]);
        return;
      }
      if (e.target.closest('.mtx-card__x') || !e.target.closest('.mtx-pop')) openPart('');
    });
    // Close the part when the shopper moves to another gallery slide
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        if (activeKey && !en[0].isIntersecting) openPart('');
      }, { threshold: 0.5 }).observe(mtx);
    }

    mtx.classList.add('is-open'); // the scene stands still; the only motion is the zoom to a part

    // Coming from the 3D slide: the poster starts big and centred like in the 3D view, then flies to its
    // place while the magnet and sticker come out from behind it
    // Going back to 3D plays it in reverse: this slide stays on top while the poster flies to the 3D pose, then fades
    var slideX = mtx.closest('.mtg-slide'), slide3d = document.querySelector('.mtg-slide-3d'), wasOn3d = true, wasOnX = false;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slideX && slide3d && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var xOn = slideX.classList.contains('is-on'), on3d = slide3d.classList.contains('is-on');
        if (!calm && xOn && !wasOnX && wasOn3d) arrive();
        if (!calm && !xOn && wasOnX && on3d) leave(slideX);
        wasOn3d = on3d; wasOnX = xOn;
      }).observe(slideX, { attributes: true, attributeFilter: ['class'] });
    }
  }
  function startScale() {
    var plate = mtx.querySelector('.mtx-plate');
    if (!plate || !plate.offsetHeight) return false;
    var es = Math.min(mtx.clientHeight * 0.8 / plate.offsetHeight, mtx.clientWidth * 0.8 / plate.offsetWidth);
    mtx.style.setProperty('--es', es.toFixed(3));
    return true;
  }
  function leave(slideX) {
    clearTimeout(arrive.t);
    mtx.classList.remove('is-enter', 'is-arriving');
    slideX.classList.add('is-leaving'); // keeps it shown above the 3D slide for the move
    openPart('');
    if (!startScale()) { slideX.classList.remove('is-leaving'); return; }
    void mtx.offsetWidth;
    mtx.classList.add('is-exit');
    clearTimeout(leave.t);
    leave.t = setTimeout(function () {
      slideX.classList.remove('is-leaving');
      mtx.classList.remove('is-exit');
    }, 1000);
  }
  function arrive() {
    clearTimeout(leave.t);
    mtx.classList.remove('is-exit');
    if (mtx.closest('.mtg-slide')) mtx.closest('.mtg-slide').classList.remove('is-leaving');
    openPart('');
    if (!startScale()) return;
    mtx.classList.add('is-enter', 'is-arriving');
    void mtx.offsetWidth; // start from the 3D pose before the first paint
    requestAnimationFrame(function () {
      mtx.classList.remove('is-enter');
      clearTimeout(arrive.t);
      arrive.t = setTimeout(function () { mtx.classList.remove('is-arriving'); }, 1500);
    });
  }

  // Camera: zoom in on a part (sticker / magnet / poster), or back out
  var zoom = { s: 1, x: 0, y: 0 };
  function setCam(s, x, y) {
    zoom = { s: s, x: x, y: y };
    var cam = $('mtx-cam');
    cam.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
    cam.style.setProperty('--hz', (1 / s).toFixed(3)); // keeps the "+" buttons the same size
  }
  // Zooms in on a part (centred) and puts the explanation just above it, or over its top when there's no room
  function zoomTo(key) {
    if (!key) { setCam(1, 0, 0); return; }
    var el = mtx.querySelector('.mtx-' + key), sc = mtx.getBoundingClientRect(), pop = $('mtx-pop');
    if (!el || !sc.width) return;
    var r = el.getBoundingClientRect();
    // the part's box without the current zoom
    var w = r.width / zoom.s, h = r.height / zoom.s;
    var cx = (r.left + r.width / 2 - sc.left - zoom.x) / zoom.s, cy = (r.top + r.height / 2 - sc.top - zoom.y) / zoom.s;
    var W = sc.width, H = sc.height, ph = pop.offsetHeight || 110, cap = key === 'plate' ? 1.6 : 2.6;
    var room = H - ph - 40; // height left under the explanation
    var s = Math.min(cap, W * 0.6 / w, room / h), above = s >= 1, top, popTop;
    if (above) {
      top = ph + 26 + Math.max(0, (room - s * h) / 3);
      popTop = top - ph - 12;
    } else {
      s = Math.max(1, Math.min(cap, W * 0.6 / w, H * 0.86 / h));
      top = (H - s * h) / 2;
      popTop = Math.max(10, top + 14);
    }
    setCam(s, W / 2 - s * cx, top + s * h / 2 - s * cy);
    pop.style.top = Math.round(Math.min(popTop, H - ph - 10)) + 'px';
  }

  function openPart(key) {
    var pop = $('mtx-pop');
    Array.prototype.forEach.call(mtx.querySelectorAll('.mtx-hot'), function (h) {
      var on = h.dataset.k === key;
      h.classList.toggle('is-on', on);
      h.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    mtx.classList.toggle('has-card', !!key);
    document.documentElement.classList.toggle('mtx-parts', !!key); // hides the gallery arrows meanwhile
    if (key) {
      var part = T.parts[key];
      card.querySelector('.mtx-card__t').textContent = part.title;
      card.querySelector('.mtx-card__p').textContent = part.text(preview);
      if (key !== activeKey) { pop.hidden = true; void pop.offsetWidth; } // replays the pop-in animation
      pop.hidden = false;
    } else {
      pop.hidden = true;
    }
    if (key !== activeKey) zoomTo(key); // after the text is in, so its height is known
    activeKey = key;
  }

  function paintScene() {
    if (!mtx || !preview) return;
    var p = preview, list = sizesList(), n = list.length, i = sizeIndex(p.size);
    var dbl = (CFG.doubleSizes || []).indexOf(p.size) > -1;
    buildRig(dbl);
    // Poster scale by size: 3 sizes -> 80% / 100% / 120%; more sizes spread a bit wider
    var s = n < 2 ? 1 : n <= 3 ? 0.8 + 0.4 * i / (n - 1) : 0.72 + 0.6 * i / (n - 1);
    var w = 22 * s, h = 33 * s;
    if (p.orientation === 'landscape') { var t = w; w = h; h = t; }
    var rig = mtx.querySelector('.mtx-rig');
    rig.style.setProperty('--pw', w.toFixed(2) + 'em');
    rig.style.setProperty('--ph', h.toFixed(2) + 'em');
    mtx.classList.toggle('is-matte', p.finish === 'matte');
    mtx.classList.toggle('is-land', p.orientation === 'landscape');
    $('mtx-size').textContent = dimsText(p) + ' ' + T.cm + ' · ' + (p.finish === 'matte' ? T.matte : T.gloss);
    var plate = mtx.querySelector('.mtx-plate');
    plate.classList.toggle('is-blank', !p.image);
    // The builder repaints the same canvas on every change (crop, B&W...), so always copy it
    if (p.image) paintCover(plateCanvas, p.image, Math.round(w * 14), Math.round(h * 14));
    if (activeKey) {
      openPart(activeKey); // finish text follows the picked finish
      clearTimeout(paintScene.t); // the poster may have changed size: frame it again once it has grown
      paintScene.t = setTimeout(function () { if (activeKey) zoomTo(activeKey); }, 600);
    }
  }

  // ---------- 2. Sizes sheet ----------
  var sheet = null, sheetItems = [];
  function buildSheet() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'mts';
    sheet.dir = 'rtl';
    sheet.hidden = true;
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'mts-title');
    var items = (CFG.sizeGuide || []).map(function (g, i) {
      return '<button type="button" class="mts__item" data-i="' + i + '" data-id="' + g.id + '">' +
        '<span class="mts__label"><b class="mts__id">' + g.id + '</b><span class="mts__dims"></span><span class="mts__price"></span><span class="mts__on">' + T.picked + '</span></span>' +
        // Portrait: the poster shows through the mockup's cut-out. Landscape: the same person holding it sideways
        // (body with the cut-out filled in, poster in front, then her thumbs on top).
        '<span class="mts__card"><span class="mts__fig">' +
          (g.land ? '<img class="mts__land" src="' + g.land.img + '" alt="" loading="lazy" width="1024" height="1024">' : '') +
          '<span class="mts__poster is-blank"><canvas></canvas></span>' +
          '<img class="mts__mock" src="' + g.img + '" alt="" loading="lazy" width="1024" height="1024">' +
          (g.land ? '<img class="mts__fingers" src="' + g.land.fingers + '" alt="" loading="lazy" width="1024" height="1024">' : '') +
        '</span></span>' +
      '</button>';
    }).join('');
    sheet.innerHTML =
      '<div class="mts__bg"></div>' +
      '<div class="mts__panel">' +
        '<div class="mts__head">' +
          '<svg class="mts__icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="8" width="18" height="8" rx="1.5"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4" /></svg>' +
          '<h2 class="mts__title" id="mts-title">' + T.sheetTitle + '</h2>' +
          '<button type="button" class="mts__x" aria-label="' + T.close + '"><svg viewBox="0 0 24 24"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button>' +
        '</div>' +
        '<div class="mts__body">' +
          '<p class="mts__sub" id="mts-sub"></p>' +
          '<p class="mts__note" id="mts-note" hidden><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5"/></svg><span></span></p>' +
          '<div class="mts__list">' + items + '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheetItems = Array.prototype.slice.call(sheet.querySelectorAll('.mts__item'));
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('.mts__x') || e.target.classList.contains('mts__bg')) { closeSheet(); return; }
      var it = e.target.closest('.mts__item');
      if (!it) return;
      var chip = $('mtp-sizes') && $('mtp-sizes').children[sizeIndex(it.dataset.id)];
      if (chip) chip.click();
      setTimeout(closeSheet, 380);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet(); });
  }
  function paintSheet() {
    if (!sheet || sheet.hidden || !preview) return;
    var p = preview, chips = $('mtp-sizes') ? $('mtp-sizes').children : [];
    var land = p.orientation === 'landscape';
    $('mts-sub').textContent = T.sheetSub;
    $('mts-note').hidden = !land;
    $('mts-note').querySelector('span').textContent = T.sheetLandscape;
    sheet.classList.toggle('is-land', land);
    sheetItems.forEach(function (it) {
      var g = CFG.sizeGuide[+it.dataset.i];
      var useLand = land && g.land;
      // a hair bigger than the cut-out so no gap shows at its soft edge; in landscape the poster sits in front
      var rect = useLand ? g.land.rect : g.hole, pad = useLand ? 0 : 0.2;
      var box = it.querySelector('.mts__poster');
      box.style.left = (rect[0] - pad) + '%'; box.style.top = (rect[1] - pad) + '%';
      box.style.width = (rect[2] + 2 * pad) + '%'; box.style.height = (rect[3] + 2 * pad) + '%';
      it.classList.toggle('is-land', !!useLand);
      var i = sizeIndex(it.dataset.id), s = sizesList()[i];
      var chip = chips[i];
      it.querySelector('.mts__dims').textContent = s.a + '×' + s.b + ' ' + T.cm;
      var sub = chip && chip.querySelector('.mtp-opt-sub');
      it.querySelector('.mts__price').textContent = sub ? sub.textContent : '';
      it.classList.toggle('is-on', p.size === it.dataset.id);
      it.setAttribute('aria-pressed', p.size === it.dataset.id ? 'true' : 'false');
      box.classList.toggle('is-blank', !p.image);
      if (p.image) paintCover(box.querySelector('canvas'), p.image, useLand ? 450 : 300, useLand ? 300 : 450);
    });
  }
  function openSheet() {
    buildSheet();
    sheet.hidden = false;
    document.documentElement.classList.add('mtp-lock');
    paintSheet();
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-open'); }); });
    var on = sheet.querySelector('.mts__item.is-on');
    sheet.querySelector('.mts__x').focus({ preventScroll: true });
    if (on) setTimeout(function () { on.scrollIntoView({ block: 'nearest' }); }, 60);
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('mtp-lock');
    setTimeout(function () { sheet.hidden = true; }, 260);
  }
  var guideBtn = $('mtp-size-guide');
  if (guideBtn) {
    if (!CFG.sizeGuide || !CFG.sizeGuide.length) guideBtn.hidden = true;
    else guideBtn.addEventListener('click', openSheet);
  }

  // ---------- Follow the builder ----------
  document.addEventListener('mtp:preview', function (e) {
    preview = e.detail;
    paintScene();
    paintSheet();
  });
  paintScene();
})();
